import { render, staticRenderFns } from "./MatchConsentSignerStep.vue?vue&type=template&id=492bf506"
import script from "./MatchConsentSignerStep.vue?vue&type=script&lang=js"
export * from "./MatchConsentSignerStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports